import { ExportRequest } from '@pxtra-client-lib-legacy/gen';
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../lib/util';

export function useExportCreate(options = {}) {
  return useMutation({
    mutationFn: async ({ request }: { request: ExportRequest }) => {
      return await apiClient.impex.impexExportCreate({ requestBody: request });
    },
    ...options
  });
}
